import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import styles from './App.module.css'
import './App.css'
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/pt-mono';
import '@fontsource/plus-jakarta-sans';
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";


import { AdminRoutes, AscRoutes, ManagerRoutes } from 'routing';
import { getTenant } from './getTenant';

const tenants = {
  manager: ManagerRoutes,
  asc: AscRoutes,
  admin: AdminRoutes
};
const tenant = getTenant();

const App = () => {

  
  const Routes = tenants[tenant];

  if (!Routes) {
    return <h2>Страница не найдена!</h2>;
  }

  return (
    <main role='main' className={styles.wrapper}>
      <Routes />
    </main>
  );
}

export default App;
